export { default } from './Spin';
export { SpinWithControll } from './SpinWithControll';
